import React, { Component } from "react"

/* Helpers */
import { utils } from "../constants"


/* Component Header */
class Header extends Component {

    /* Install Box */
    _install = () => {

        /* Fields */
        const userAgent = navigator.userAgent

        /* Determine Device */
        const device = utils.device(userAgent)

        /* Check Mobile */
        if (device.type === "mobile") {

            {/* Android */ }
            if (device.os === "android") {
                return (
                    <a href="https://play.google.com/store/apps/details?id=kz.bookify.app" className="header-install-container">
                        <img src="/images/google-play.png" alt="Google Play" />
                        <div className="header-install-text">Скачать&nbsp;приложение</div>
                    </a>
                )
            }

            {/* IOS */ }
            if (device.os === "ios") {
                return (
                    <a href="https://apps.apple.com/app/apple-store/id6741415952" className="header-install-container">
                        <img src="/images/app-store.png" alt="App Store" />
                        <div className="header-install-text">Скачать&nbsp;приложение</div>
                    </a>
                )
            }

        }
    }


    render = () => {
        return (
            <div className="header-block">

                {/* Logo */}
                <img src="/images/logo.png" alt="logo" />

                {/* Install Box */}
                {this._install()}

            </div>
        )
    }

}

export default Header

